import {
  AfterViewChecked,
  Component,
  ElementRef,
  inject,
  signal,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AIStore } from '@core/ai/ai.store';
import { HighlightHandler } from '@core/handler/highlight.handler';
import { NavigationHandler } from '@core/handler/navigation.handler';
import { TranslatePipe } from '@ngx-translate/core';
import { MarkdownComponent } from 'ngx-markdown';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'crm-wattson',
  imports: [FormsModule, MatButtonModule, MatIconModule, TranslatePipe, MarkdownComponent],
  templateUrl: './wattson.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './wattson.component.scss',
})
export class WattsonComponent implements AfterViewChecked {
  protected readonly aiStore = inject(AIStore);
  protected readonly navigationHandler = inject(NavigationHandler);
  protected readonly highlightHandler = inject(HighlightHandler);
  protected readonly isEnabled = environment.wattson;

  protected readonly isOpen = signal(false);
  protected inputText = '';

  @ViewChild('messageList') messageList!: ElementRef<HTMLElement>;

  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  private scrollToBottom(): void {
    try {
      const el = this.messageList?.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
    } catch {
      // ignore
    }
  }

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }

  sendMessage(): void {
    const question = this.inputText.trim();
    if (!question || this.aiStore.isLoading()) return;
    this.aiStore.sendMessage(question);
    this.inputText = '';
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }
}
